import { useContextWithCheckValue } from '@edikk-edikk/hooks';
import { SeoBlockContext } from '../contexts';

const useSeoBlockContext = () => useContextWithCheckValue(SeoBlockContext);

export { useSeoBlockContext };
